<template>
  <router-link
    :to="`/your-stuff/tasks/${task.id}`"
    class="phone-task-row"
    :data-testid="`phone-task-row-${task.key}`"
  >
    <PhoneTaskTypeIcon :kind="task.kind" />
    <span class="phone-task-row__text">
      <span class="phone-task-row__type">{{ task.typeLabel }}</span>
      <span v-if="detailLine" class="phone-task-row__detail" data-testid="phone-task-row-detail">
        {{ detailLine }}
      </span>
      <span
        v-if="deadlineLabel"
        class="phone-task-row__deadline"
        data-testid="phone-task-row-deadline"
      >
        Due {{ deadlineLabel }}
      </span>
    </span>
    <span class="phone-task-row__status">
      <TaskStatusBadge :task-status="task.status" />
      <svg
        class="phone-task-row__chevron"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <path d="M9 18l6-6-6-6" />
      </svg>
    </span>
  </router-link>
</template>

<script setup>
import { computed } from "vue";
import TaskStatusBadge from "@components/TaskStatusBadge/TaskStatusBadge.vue";
import PhoneTaskTypeIcon from "../PhoneTaskTypeIcon/PhoneTaskTypeIcon.vue";
import { formatPhoneTaskDate, phoneTaskDetailLine } from "@/utils/phoneTasks";

const props = defineProps({
  task: {
    type: Object,
    required: true,
  },
});

const detailLine = computed(() => phoneTaskDetailLine(props.task));
const deadlineLabel = computed(() => formatPhoneTaskDate(props.task.deadline));
</script>

<style scoped>
.phone-task-row {
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  min-height: 82px;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #eaecf0;
  border-radius: 12px;
  color: #101828;
  text-decoration: none;
  font-family: "Inter", sans-serif;
}

.phone-task-row:focus-visible {
  outline: 2px solid #7f56d9;
  outline-offset: 2px;
}

.phone-task-row__text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  overflow-wrap: anywhere;
}

.phone-task-row__type {
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #101828;
}

.phone-task-row__detail {
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #475467;
}

.phone-task-row__deadline {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: #344054;
}

.phone-task-row__status {
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.phone-task-row__chevron {
  color: #475467;
}
</style>
